
import { defineComponent } from "vue";
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from "chart.js";

import ButtonDownloadTable from "~/vue/atoms/buttons/ButtonDownloadTable.vue";
import CardCareer from "~/vue/molecules/cards/CardCareer.vue";
import CardEvent from "~/vue/molecules/cards/CardEvent.vue";
import CardFeatured from "~/vue/molecules/cards/CardFeatured.vue";
import CardKnowledgeHub from "~/vue/molecules/cards/CardKnowledgeHub.vue";
import CardLocation from "~/vue/molecules/cards/CardLocation.vue";
import CardLocationCompact from "~/vue/molecules/cards/CardLocationCompact.vue";
import CardPrimary from "~/vue/molecules/cards/CardPrimary.vue";
import ConsentForm from "~/vue/organisms/consents/ConsentForm.vue";
import ConsentHidden from "~/vue/organisms/consents/ConsentHidden.vue";
import ConsentMedia from "~/vue/organisms/consents/ConsentMedia.vue";
import FormHubspot from "~/vue/organisms/forms/FormHubspot.vue";
import FormieForm from "~/vue/organisms/forms/FormieForm.vue";
import GraphBar from "~/vue/organisms/graphs/GraphBar.vue";
import GraphDoughnut from "~/vue/organisms/graphs/GraphDoughnut.vue";
import GraphScatter from "~/vue/organisms/graphs/GraphScatter.vue";
import GridMediaGallery from "~/vue/organisms/grids/GridMediaGallery.vue";
import LinkDocumentConsent from "~/vue/atoms/links/LinkDocumentConsent.vue";
import MapCountries from "~/vue/organisms/maps/MapCountries.vue";
import SliderBeforeAfter from "~/vue/organisms/sliders/SliderBeforeAfter.vue";
import SliderCards from "~/vue/organisms/sliders/SliderCards.vue";
import SliderCta from "~/vue/organisms/sliders/SliderCta.vue";
import SliderGallery from "~/vue/organisms/sliders/SliderGallery.vue";
import SliderLocationCards from "~/vue/organisms/sliders/SliderLocationCards.vue";
import SliderSdgs from "~/vue/organisms/sliders/SliderSdgs.vue";
import SliderTestimonials from "~/vue/organisms/sliders/SliderTestimonials.vue";
import LightboxSingleImage from "~/vue/organisms/lightboxes/LightboxSingleImage.vue";
import GridFaq from "~/vue/organisms/grids/GridFaq.vue";
import GroupFaq from "~/vue/organisms/grids/GroupFaq.vue";
import GridRegionalLocations from "~/vue/organisms/grids/GridRegionalLocations.vue";

ChartJS.register({
	id: "backgroundBar",
	beforeDatasetsDraw(chart) {
		const {
			data,
			ctx,
			chartArea: { top, width, height },
			scales: { x },
		} = chart;

		const segment = width / data.labels.length;
		let barWidth = segment * data.datasets[0].barPercentage * data.datasets[0].categoryPercentage;
		barWidth = barWidth > 40 ? 40 : barWidth;
		const cornerRadius = barWidth;

		ctx.fillStyle = "#F0EFEF";
		ctx.strokeStyle = "#F0EFEF";
		ctx.lineJoin = "round";
		ctx.lineWidth = cornerRadius;

		data.labels.forEach((_, i) => {
			const bgX = x.getPixelForValue(i) - barWidth * 0.5 + cornerRadius * 0.5;
			const bgY = top + cornerRadius * 0.5;
			const bgWidth = barWidth - cornerRadius;
			const bgHeight = height - cornerRadius;
			ctx.strokeRect(bgX, bgY, bgWidth, bgHeight);
			ctx.fillRect(bgX, bgY, bgWidth, bgHeight);
		});
	},
});

export default defineComponent({
	components: {
		"button--download-table": ButtonDownloadTable,
		"card--career": CardCareer,
		"card--event": CardEvent,
		"card--featured": CardFeatured,
		"card--knowledge-hub": CardKnowledgeHub,
		"card--location-compact": CardLocationCompact,
		"card--location": CardLocation,
		"card--primary": CardPrimary,
		"consent--form": ConsentForm,
		"consent--hidden": ConsentHidden,
		"consent--media": ConsentMedia,
		"form--hubspot": FormHubspot,
		"form--primary": FormieForm,
		"graph--bar": GraphBar,
		"graph--doughnut": GraphDoughnut,
		"graph--scatter": GraphScatter,
		"grid--media-gallery": GridMediaGallery,
		"lightbox--single-image": LightboxSingleImage,
		"link--document-consent": LinkDocumentConsent,
		"map--countries": MapCountries,
		"slider--before-after": SliderBeforeAfter,
		"slider--cards": SliderCards,
		"slider--cta": SliderCta,
		"slider--gallery": SliderGallery,
		"slider--location-cards": SliderLocationCards,
		"slider--sdgs": SliderSdgs,
		"slider--testimonials": SliderTestimonials,
		"grid--faq": GridFaq,
		"group--faq": GroupFaq,
		"grid--regional-locations": GridRegionalLocations,
	},
});
